import { GET, POST, PUT, DELETE } from './api'

const table = "post-metrics"
export const API_ENDPOINT = process.env.REACT_APP_API_URL;

export const GetPosts = async (campaignId, { startDate, endDate }) => {
    const response = await fetch(`${API_ENDPOINT}/${table}/posts?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);

    return await response.json();
};

export const GetSumMetricsByInfluencerAndPlatform = async (campaignId, { startDate, endDate }) => {
    const response = await fetch(`${API_ENDPOINT}/${table}/sum-metrics-by-influencer-and-platform?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);

    return await response.json();
};

export const GetSumMetricsGroupedByDate = async (campaignId, { startDate, endDate }) => {
    const response = await fetch(`${API_ENDPOINT}/${table}/sum-metrics-grouped-by-date?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);

    return await response.json();
};

export const GetSumAllMetrics = async (campaignId, { startDate, endDate }) => {
    const response = await fetch(`${API_ENDPOINT}/${table}/sum-all-metrics?campaignId=${campaignId}&startDate=${startDate}&endDate=${endDate}`);

    return await response.json();
};

export const UpdateMetricsOnDemand = async (campaignId) => {
    const response = await fetch(`${API_ENDPOINT}/${table}/update-metrics-on-demand?campaignId=${campaignId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return await response.json();
};
